import { load, store } from "../localStorage"

const LOCAL_STORAGE_KEY = "view"
const GLOBAL_STORAGE_KEY = "data"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  getButtonState() {
    this.showButton =
      this.formValues["bodyParts"] === null || this.formValues["bodyParts"].length > 0
  },

  populateFormValuesFromStorage(values) {
    const globalData = load(GLOBAL_STORAGE_KEY)
    values.map((value) => {
      const globalMatch = globalData.values[value]

      this.formValues[value] = globalMatch
    })

    this.getButtonState()
  },

  updateBodyParts(key) {
    if (key === "null") {
      this.formValues.bodyParts = this.formValues.bodyParts === null ? [] : null
    } else {
      this.formValues.bodyParts =
        this.formValues.bodyParts && this.formValues.bodyParts.includes(key) ? [] : [key]
    }
  },

  bodyPartSelectedForKey(key) {
    if (this.formValues.bodyParts === null) {
      return key === "null"
    } else {
      return this.formValues.bodyParts.includes(key)
    }
  },
})
